/**
 * WARNING: This file was auto-generated by svgr. Do not edit.
 */
import * as React from 'react'
import type { SVGProps } from 'react'
/**
 * @internal
 */
const SvgChatFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <g fill="#FF2929" fillRule="evenodd" clipPath="url(#chat-filled_svg__a)" clipRule="evenodd">
      <path d="M0 2.444C0 1.094 1.231 0 2.75 0h10.5C14.769 0 16 1.094 16 2.444v12.084c0 .26-.17.495-.434.604a.83.83 0 0 1-.8-.095l-3.691-2.774a1.35 1.35 0 0 0-.807-.263H2.75C1.231 12 0 10.906 0 9.556zm2.75-1.11c-.69 0-1.25.497-1.25 1.11v7.112c0 .613.56 1.11 1.25 1.11h7.518c.65 0 1.279.205 1.775.579L14.5 13.09V2.444c0-.613-.56-1.11-1.25-1.11z" />
      <path d="M3 4c0-.245.224-.444.5-.444h9c.276 0 .5.199.5.444 0 .246-.224.445-.5.445h-9c-.276 0-.5-.2-.5-.445m0 1.778c0-.246.224-.445.5-.445h9c.276 0 .5.2.5.445s-.224.444-.5.444h-9c-.276 0-.5-.199-.5-.444m0 1.778c0-.246.224-.445.5-.445h5c.276 0 .5.2.5.445S8.776 8 8.5 8h-5c-.276 0-.5-.199-.5-.444" />
    </g>
    <defs>
      <clipPath id="chat-filled_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgChatFilled
